export default __webpack_public_path__ + "static/media/Stitching_tool.3c54b434.png";